import {
  programsDepressionAnxietyUnenrollReason,
  programsHypertensionUnenrollReason,
  programsDiabetesUnenrollReason,
  programsAdhdAddUnenrollReason,
} from '@fireflyhealth/api'

export const REASON_OPTIONS = {
  PATIENT_IS_STABLE: 'Patient is stable',
  DIAGNOSED_BY_MISTAKE: 'Diagnosed by mistake',
  PATIENT_NOT_RESPONDING: 'Patient is not responding',
  OTHER: 'Other',
}

// Single source of truth for the clinical programs that require a reason to
// unenroll from: each UID maps to its generated per-program client. Consumed by
// the Programs tab, which routes to these typed clients.
export const PROGRAM_UNENROLL_CLIENTS = {
  DepressionAndAnxiety: programsDepressionAnxietyUnenrollReason,
  Hypertension: programsHypertensionUnenrollReason,
  Diabetes: programsDiabetesUnenrollReason,
  AdhdAdd: programsAdhdAddUnenrollReason,
}

type UnenrollReasonRequiredProgramUid = keyof typeof PROGRAM_UNENROLL_CLIENTS

// Narrows an opaque program UID (the API returns `string`) to one whose program
// requires a reason to unenroll, so callers can route to the typed client.
export const requiresUnenrollReason = (uid: string): uid is UnenrollReasonRequiredProgramUid =>
  uid in PROGRAM_UNENROLL_CLIENTS
